import type { GapDraftView } from '@momentum/types';

import {
  passedCheckCount,
  readinessChecks,
  REQUIRED_GAP_FIELD_COUNT,
} from '../lib/readiness';

/**
 * The publish gate: which of `Gap`'s four required fields this draft satisfies,
 * and a publish button that is visibly disabled rather than absent.
 *
 * Hiding the control would read as "not built yet". It is disabled for a reason
 * worth stating: promotion into `gaps` is out of scope, and separately no draft
 * could pass the gate even if it were wired up — the published read path filters
 * on company and `isDeleted` only, so anything written there is immediately live
 * on the customer-facing page.
 */
export function ReadinessChecklist({ draft }: { draft: GapDraftView }) {
  const checks = readinessChecks(draft);

  return (
    <div className="gr-gate">
      <div className="gr-gate-h">
        Publishable? {passedCheckCount(checks)} of {REQUIRED_GAP_FIELD_COUNT}{' '}
        fields
      </div>
      <ul className="gr-checks">
        {checks.map((check) => (
          <li key={check.label} data-ok={check.ok}>
            <b>{check.ok ? '✓' : '✗'}</b>
            <span>
              {check.label} — {check.detail}
            </span>
          </li>
        ))}
      </ul>
      <button className="gr-btn gr-btn-block" type="button" disabled>
        Publish to gaps
      </button>
      <p className="gr-gate-reason">
        Disabled for every draft: promotion into <code>gaps</code> is out of
        scope for v1.
      </p>
    </div>
  );
}
